import { render, staticRenderFns } from "./GamesSettings.vue?vue&type=template&id=705b78e2&scoped=true"
import script from "./GamesSettings.vue?vue&type=script&lang=js"
export * from "./GamesSettings.vue?vue&type=script&lang=js"
import style0 from "./GamesSettings.vue?vue&type=style&index=0&id=705b78e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705b78e2",
  null
  
)

export default component.exports